import { Pipe, PipeTransform } from '@angular/core';
import * as labels from './labels.json';
@Pipe({
  name: 'label',
})
export class LabelPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): string {
    const label = labels && labels[value] ? labels[value] : value;
    return label;
  }
}
